import { render, staticRenderFns } from "./relationPresTransferWay.vue?vue&type=template&id=6943b6a2&scoped=true&"
import script from "./relationPresTransferWay.vue?vue&type=script&lang=ts&"
export * from "./relationPresTransferWay.vue?vue&type=script&lang=ts&"
import style0 from "./relationPresTransferWay.vue?vue&type=style&index=0&id=6943b6a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6943b6a2",
  null
  
)

export default component.exports